export const NEW_PATTERN_REGION_CODES = ['CA'];

export default {
  NEW_PATTERN_REGION_CODES,
};
